import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable, Filter, FilterTag } from "../../../../../../../components";
import rebateModeEnum from "../../../../../../../enumerations/rebateModeEnum";
import { filterKey } from "../../enumerations/filterKeyEnum";
import { filterSetup } from "../../enumerations/filterSetupEnum";
import { useGetDownlineNewRegister } from "../../hooks/downlinedetail.hooks";

const NewRegister = ({ startAt = null, endAt = null, rebateMode = undefined }) => {
  const { t } = useTranslation();

  const [localData, setLocalData] = useState([]);
  const [filterDefaultValue, setFilterDefaultValue] = useState({
    [filterKey.ACCOUNT]: "",
    [filterKey.AGENT_ACCOUNT]: "",
    [filterKey.LEVEL]: "all",
  });
  const [filterValue, setFilterValue] = useState({
    [filterKey.ACCOUNT]: "",
    [filterKey.AGENT_ACCOUNT]: "",
    [filterKey.LEVEL]: "all",
  });

  const {
    data: newRegister,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    isError,
  } = useGetDownlineNewRegister({
    params:
      rebateMode !== rebateModeEnum.WINLOSE
        ? {
            start_at: startAt,
            end_at: endAt,
            ...filterValue,
          }
        : {
            start_at: startAt,
            end_at: endAt,
          },
    options: {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
    },
    enabled: startAt !== null && endAt !== null,
  });

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  const onHandleSearch = () => {};

  useEffect(() => {
    if (newRegister) {
      const page_length = newRegister.pages.length;
      if (page_length <= 1) {
        setLocalData([...newRegister.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...newRegister.pages[page_length - 1].data];
        });
      }
    }
  }, [newRegister]);

  const columns = [
    {
      title: t("downlineReport.register.date"),
      width: 170,
      valueType: "dateTime",
      dataIndex: "register_date",
      align: "center",
      render: (_, record) => (
        <span>{record.register_date ? dayjs(record.register_date).format("YYYY-MM-DD") : "-"}</span>
      ),
    },
    {
      title: t("normal.account"),
      width: 240,
      dataIndex: "account",
      align: "center",
    },
    {
      title: t("normal.level"),
      width: 100,
      dataIndex: "level",
      align: "center",
      hideInTable: rebateMode === rebateModeEnum.WINLOSE,
    },
    {
      title: t("normal.agent.account"),
      width: 240,
      dataIndex: "agent_account",
      align: "center",
      hideInTable: rebateMode === rebateModeEnum.WINLOSE,
    },
    {
      title: t("normal.uid"),
      width: 100,
      dataIndex: "account_id",
      align: "center",
    },
  ];

  const renderFilter = () => {
    if (rebateMode && rebateMode !== rebateModeEnum.WINLOSE) {
      return (
        <>
          <Filter
            filterSetup={filterSetup}
            filterDefaultValue={filterDefaultValue}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            onReset={() => {
              //if need some aditional reset logic in the page
              console.debug("RESET FILTER");
            }}
            onSubmitSearch={onHandleSearch}
          />
          <FilterTag
            filterSetup={filterSetup}
            filterValue={filterValue}
            filterDefaultValue={filterDefaultValue}
            setFilterValue={setFilterValue}
            refreshSearch={onHandleSearch}
          />
        </>
      );
    }
    return null;
  };

  return (
    <div>
      {renderFilter()}
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
        />
      )}
    </div>
  );
};

export default NewRegister;
